import _ from "lodash";
import React from "react";
import { NoSearchInFilterIllustration } from "@toddle-edu/ds-theme";
import { Button, EmptyState } from "@toddle-edu/ds-web";

const SearchTextEmptyState = props => {
  const { t, title, subtitle, resetFilters = _.noop } = props;
  return (
    <EmptyState
      illustration={NoSearchInFilterIllustration}
      title={title}
      subtitle={subtitle}
      primaryButton={
        <Button onClick={resetFilters} type={"outlined"} variant={"neutral"}>
          {t("common:reset")}
        </Button>
      }
    />
  );
};

export default SearchTextEmptyState;
